export const ro = {
    // Header
    header: {
        contact: {
            phone: "+40 743 131 559",
            email: "office@terasamente.com"
        },
        topBarText: "Peste 192+ Utilaje de Calitate Disponibile",
        nav: {
            home: "Acasă",
            searchMachinery: "Toate Utilajele",
            about: "Despre Noi",
            services: "Servicii",
            contact: "Contact",
            publishAd: "Publică Anunț",
            allCategories: "Toate Categoriile",
            selectCategory: "Selectează o categorie",
            hotspot: "HotSpot",
            hotspotTitle: "🔥 HotSpot",
            hotspotSubtitle: "Oferte speciale selectate pentru tine",
            loadingOffers: "Se încarcă ofertele...",
            noOffersAvailable: "Nu există oferte speciale momentan",
            viewFullDetails: "Vezi Detalii Complete",
            negotiable: "NEGOCIABIL",
            year: "AN",
            hours: "ORE",
            location: "LOCAȚIE",
            price: "PREȚ",
            quickFilters: "Filtre rapide:"
        },
        hero: {
            badge: "20+ Ani de Experiență",
            title: {
                line1: "Utilaje de Construcții",
                line2: "Profesionale",
                line3: "de Vânzare"
            },
            subtitle: "Excavatoare • Încărcătoare • Compactoare • Servicii Transport • Echipament de Calitate",
            buttons: {
                browse: "Inventar Utilaje",
                services: "Serviciile Noastre"
            },
            features: {
                search: {
                    title: "CAUTĂ",
                    description: "Găsește utilajul perfect"
                },
                categories: {
                    title: "CATEGORII",
                    description: "Filtrează după categorie"
                },
                contact: {
                    title: "CONTACTEAZĂ",
                    description: "Obține toate informațiile"
                },
                purchase: {
                    title: "Cumpără",
                    description: "Testează și cumpără cu încredere"
                }
            }
        }
    },

    // Inventory
    inventory: {
        badge: "Ultimele Adăugări",
        title: {
            part1: "Utilaje",
            part2: "Recomandate"
        },
        subtitle: "Descoperă selecția noastră de echipamente de construcții de înaltă calitate",
        categories: {
            loaders: "Încărcătoare",
            excavators: "Excavatoare",
            compactors: "Compactoare"
        },
        condition: {
            excellent: "Excelent",
            veryGood: "Foarte Bun",
            good: "Bun",
            likeNew: "Ca Nou"
        },
        negotiable: "Negociabil",
        hours: "Ore",
        viewDetails: "Vezi Detalii",
        viewAll: "Vezi Toate Utilajele",
        available: "Disponibile"
    },

    // Announcement Details
    announcementDetails: {
        whatsappButton: "Contact pe WhatsApp",
        backToListings: "Înapoi la listă",
        noImagesAvailable: "Nu există imagini disponibile",
        description: "Descriere",
        noDescription: "Nu există descriere disponibilă.",
        details: "Detalii",
        category: "Categorie",
        manufacturer: "Producător",
        model: "Model",
        year: "An",
        condition: "Condiție",
        hours: "Ore",
        location: "Locație",
        locationTitle: "Locație",
        locationNotSpecified: "Locație nespecificată",
        status: "Status",
        views: "vizualizări",
        additionalInfo: "Informații Suplimentare",
        yearOfManufacture: "An fabricație",
        weight: "Greutate",
        power: "Putere",
        capacity: "Capacitate",
        price: "PREȚ",
        negotiable: "Negociabil",
        contactNotAvailable: "Contact indisponibil",
        contactLabel: "Contact",
        detailsLabel: "Detalii",
        notProvided: "Nespecificat",
        callNow: "Apelează Acum"
    },

    // Categories Page
    categoriesPage: {
        title: "Toate Categoriile",
        subtitle: "Explorează gama completă de utilaje și echipamente disponibile"
    },

    // Filters
    filters: {
        activeFilters: "Filtre Active",
        clearAll: "Șterge Toate",
        noFiltersApplied: "Nu sunt aplicate filtre. Folosește filtrele de mai sus pentru a-ți rafina căutarea.",
        remove: "Elimină",
        price: "Preț",
        year: "An",
        hours: "Ore",
        now: "Acum",
        advancedFilters: "Filtre Avansate",
        closeFilters: "Închide filtrele",
        condition: "Condiție",
        priceRange: "Interval Preț",
        yearLabel: "An",
        minYear: "An Minim",
        maxYear: "An Maxim",
        workingHours: "Ore de Lucru",
        minHours: "Ore Minime",
        maxHours: "Ore Maxime",
        brands: "Mărci",
        clearAllFilters: "Șterge Toate Filtrele",
        advancedFiltersButton: "Filtre Avansate"
    },
    
    // Machinery Page
    machineryPage: {
        searchPlaceholder: "Caută după nume, marcă, model...",
        gridView: "Vizualizare Grilă",
        listView: "Vizualizare Listă",
        sortBy: {
            newest: "Cele Mai Noi",
            priceLow: "Preț: Crescător",
            priceHigh: "Preț: Descrescător",
            yearNew: "An: Cel Mai Nou",
            yearOld: "An: Cel Mai Vechi",
            hoursLow: "Ore: Cele Mai Puține"
        },
        applyingFilters: "Se aplică filtrele...",
        machinesFound: "Utilaje Găsite",
        machineFound: "Utilaj",
        noResultsTitle: "Nu s-au găsit utilaje",
        noResultsMessage: "Încearcă să ajustezi criteriile de căutare",
        clearFilters: "Șterge Filtrele",
        premiumEquipment: "Echipament Premium",
        available: "DISPONIBILE",
        support: "SUPORT",
        browseTitle: "Descoperă",
        browseTitleHighlight: "Utilajele Noastre Premium",
        browseSubtitle: "Găsește echipamente de construcții de cea mai înaltă calitate, adaptate nevoilor proiectului tău.",
        browseSubtitle2: "De la excavatoare la încărcătoare, găsește soluția perfectă pentru următoarea ta lucrare.",
        loadingMachinery: "Se încarcă utilajele...",
        errorRetry: "Reîncearcă",
        hotspotBadge: "🔥 HotSpot",
        year: "An",
        hours: "Ore",
        location: "Locație",
        power: "Putere",
        weight: "Greutate",
        bucket: "Cupă",
        moreFeatures: "caracteristici suplimentare",
        negotiable: "Negociabil",
        price: "Preț",
        callNow: "Sună Acum",
        viewDetails: "Vezi Detalii"
    },
    
    // Condition Types
    conditionTypes: {
        'nou': 'Nou',
        'second-hand': 'Second Hand',
        'reconditionat': 'Recondiționat'
    },
    
    // Subsub Categories
    subsubCategories: {
        'excavatoare pe șenile': 'Excavatoare pe șenile',
        'excavatoare pe roți': 'Excavatoare pe roți',
        'excavatoare pentru fier vechi': 'Excavatoare pentru fier vechi',
        'mini excavatoare': 'Mini excavatoare',
        'Cilindri compactori': 'Cilindri compactori',
        'Cilindri mici': 'Cilindri mici',
        'Cilindri tandem': 'Cilindri tandem',
        'Cilindri Polipneu': 'Cilindri Polipneu',
        'Încărcătoare frontale': 'Încărcătoare frontale',
        'Încărcătoare telescopice': 'Încărcătoare telescopice',
        'Mini încărcătoare': 'Mini încărcătoare'
    },

    // Category Names
    categoryNames: {
        'utilaje-constructii': 'UTILAJE DE CONSTRUCȚII',
        'transport': 'CAMIOANE (TRANSPORT)',
        'utilaje-agricole': 'UTILAJE AGRICOLE',
        'autoturisme-autoutilitare': 'AUTOTURISME ȘI AUTOUTILITARE',
        'excavatoare': 'EXCAVATOARE',
        'buldoexcavatoare': 'BULDOEXCAVATOARE',
        'buldozere': 'BULDOZERE',
        'cilindri-compactori': 'CILINDRI COMPACTORI',
        'gredere': 'GREDERE',
        'incarcatoare': 'ÎNCĂRCĂTOARE',
        'dumpere': 'DUMPERE',
        'automacarale': 'AUTOMACARALE',
        'autobetoniere': 'AUTOBETONIERE',
        'masini-asfalt': 'MAȘINI DE ASFALT',
        'sivuitoare': 'SIVUITOARE',
        'nacele': 'NACELE',
        'statii-sortare': 'STAȚII DE SORTARE',
        'concasoare': 'CONCASOARE',
        'accesorii-echipamente': 'ACCESORII ȘI ECHIPAMENTE',
        'dezmembrari': 'DEZMEMBRĂRI UTILAJE',
        'diverse': 'DIVERSE',
        'camioane': 'CAMIOANE',
        'trailere': 'TRAILERE',
        'semiremorci': 'SEMIREMORCI',
        'matura-stradala': 'MĂTURĂ STRADALĂ',
        'tractoare': 'TRACTOARE',
        'combine': 'COMBINE',
        'echipamente-agricole': 'ECHIPAMENTE AGRICOLE',
        'autoturisme': 'AUTOTURISME',
        'autoutilitare': 'AUTOUTILITARE (CAMIONETE)',
        'remorci': 'REMORCI'
    },

    // Call to Action
    cta: {
        badge: "Începe Astăzi",
        title: "Gata să Găsești Utilajul Perfect?",
        subtitle: "Contactează-ne acum și lasă experții noștri să te ajute să alegi echipamentul de construcții potrivit pentru nevoile tale. Suntem aici pentru tine!",
        callNow: "Sună Acum",
        sendEmail: "Trimite Email",
        seeInventory: "Vezi Utilaje",
        features: {
            response: "Răspuns rapid în 24h",
            consultation: "Consultanță gratuită",
            warranty: "Garanție calitate"
        },
        stats: {
            years: "10+",
            experience: "Ani Experiență",
            machines: "500+",
            sold: "Utilaje Vândute",
            customers: "98%",
            satisfied: "Clienți Mulțumiți"
        }
    },

    // Why Choose Us
    whyChooseUs: {
        badge: "De Ce MachineryA3",
        title: "De Ce Să Ne Alegi?",
        subtitle: "Oferim cele mai bune soluții de utilaje de construcții cu calitate și servicii de neegalat",
        features: {
            quality: {
                title: "Calitate Garantată",
                description: "Toate utilajele noastre sunt supuse unor inspecții riguroase pentru a asigura performanță și fiabilitate maximă"
            },
            certified: {
                title: "Echipament Certificat",
                description: "Fiecare utilaj vine cu documentație completă și certificare pentru liniștea ta"
            },
            delivery: {
                title: "Livrare Rapidă",
                description: "Oferim servicii de livrare rapide și sigure în toată România și Europa"
            },
            support: {
                title: "Suport 24/7",
                description: "Echipa noastră dedicată este mereu pregătită să te asiste cu orice întrebări sau nelămuriri"
            },
            experience: {
                title: "Experiență de Expert",
                description: "Peste 20 ani de experiență în industria utilajelor de construcții"
            },
            pricing: {
                title: "Prețuri Competitive",
                description: "Prețuri corecte și transparente cu opțiuni de plată flexibile disponibile"
            }
        },
        trust: {
            awards: {
                title: "Recunoaștere în Industrie",
                description: "Premiat pentru excelență în vânzări de utilaje"
            },
            rating: {
                title: "Recenzii 5 Stele",
                description: "Încrederea a sute de clienți mulțumiți"
            },
            guarantee: {
                title: "Garanție Bani Înapoi",
                description: "Satisfacția ta este prioritatea noastră"
            }
        }
    },

    // FAQ
    faq: {
        badge: "Întrebări Frecvente",
        title: {
            part1: "Ai",
            part2: "Întrebări?"
        },
        subtitle: "Găsește răspunsuri rapide la cele mai frecvente întrebări despre achiziționarea și utilizarea utilajelor noastre",
        categories: {
            buying: "Procesul de Cumpărare",
            delivery: "Transport & Livrare",
            payment: "Plăți & Finanțare",
            warranty: "Garanție & Service"
        },
        buying: [
            {
                question: "Cum pot achiziționa un utilaj de la voi?",
                answer: "Procesul este simplu: caută utilajul dorit pe site, contactează-ne telefonic sau prin email pentru detalii, programează o vizită la locație pentru a testa utilajul, și dacă ești mulțumit, finalizează achiziția. Echipa noastră te va ghida în fiecare etapă."
            },
            {
                question: "Pot testa utilajul înainte de achiziție?",
                answer: "Da, absolut! Încurajăm toți clienții să ne viziteze la locația noastră din Luna, Cluj pentru a testa utilajele. Puteți programa o demonstrație completă pentru a verifica performanța și starea tehnică a echipamentului."
            },
            {
                question: "Utilajele sunt verificate tehnic?",
                answer: "Da, toate utilajele din inventarul nostru sunt inspectate riguros și verificate tehnic înainte de a fi oferite spre vânzare. Furnizăm documentație completă despre istoricul și starea tehnică a fiecărui utilaj."
            },
            {
                question: "Pot negocia prețul?",
                answer: "Da, majoritatea utilajelor noastre au prețuri negociabile. Suntem deschiși la discuții pentru a ajunge la o înțelegere care să convină ambelor părți. Contactează-ne pentru a discuta oferte speciale."
            }
        ],
        delivery: [
            {
                question: "Oferiți servicii de transport?",
                answer: "Da, oferim servicii complete de transport agabaritic în toată România și Europa. Avem experiență în livrarea sigură a utilajelor de toate dimensiunile, inclusiv excavatoare, încărcătoare și compactoare."
            },
            {
                question: "Cât durează livrarea?",
                answer: "Timpul de livrare depinde de destinație și disponibilitatea transportului. În general, livrările în România se efectuează în 2-5 zile lucrătoare, iar cele internaționale în 5-14 zile. Vă vom oferi un termen exact la finalizarea comenzii."
            },
            {
                question: "Cât costă transportul?",
                answer: "Costul transportului variază în funcție de dimensiunea utilajului, distanță și accesibilitatea locației de livrare. Vă vom oferi o cotație detaliată de transport odată ce cunoaștem detaliile comenzii dumneavoastră."
            },
            {
                question: "Ce documente sunt necesare pentru livrare?",
                answer: "Pentru livrare veți avea nevoie de: act de identitate, documentele de înregistrare ale companiei (dacă e cazul), contract de vânzare-cumpărare, și autorizații speciale pentru transport agabaritic dacă este necesar."
            }
        ],
        payment: [
            {
                question: "Ce metode de plată acceptați?",
                answer: "Acceptăm mai multe metode de plată: transfer bancar, numerar (pentru sume mai mici), carduri bancare, și plăți în rate prin partenerii noștri financiari. Discută cu echipa noastră pentru a găsi cea mai convenabilă opțiune."
            },
            {
                question: "Oferiți opțiuni de finanțare?",
                answer: "Da, colaborăm cu instituții financiare partenere care pot oferi soluții de leasing și credite pentru achiziția de utilaje. Putem ajuta cu pregatirea documentației necesare și găsirea celei mai bune oferte de finanțare."
            },
            {
                question: "Este necesar un avans?",
                answer: "De obicei, solicităm un avans de 20-30% pentru rezervarea utilajului și începerea procesului de livrare. Restul sumei se plătește înainte sau la livrare, în funcție de acordul stabilit."
            },
            {
                question: "Emiteți factură fiscală?",
                answer: "Da, emitem factură fiscală pentru toate tranzacțiile. Dacă sunteți înregistrat ca plătitor de TVA, putem emite factura cu TVA deductibil. Furnizăm toate documentele necesare pentru contabilitate."
            }
        ],
        warranty: [
            {
                question: "Utilajele vin cu garanție?",
                answer: "Utilajele second-hand vin cu o perioadă de garanție limitată care variază în funcție de model și an. Oferim, de asemenea, opțiuni de extindere a garanției. Utilajele noi vin cu garanția completă a producătorului."
            },
            {
                question: "Ce acopera garanția?",
                answer: "Garanția acoperă defecțiunile majore ale sistemelor mecanice și hidraulice care apar în condiții normale de utilizare. Nu acoperă uzura normală, consumabilele sau daunele cauzate de utilizare inadecvată."
            },
            {
                question: "Oferiti servicii de service și întreținere?",
                answer: "Da, avem parteneriate cu service-uri autorizate și putem recomanda specialiști pentru întreținerea periodică și reparațiile necesare. De asemenea, oferim consultanță pentru mentenanța preventivă."
            },
            {
                question: "Ce se întâmplă dacă utilajul are probleme după achiziție?",
                answer: "Dacă întâmpini probleme în perioada de garanție, contactează-ne imediat. Vom evalua situația și vom oferi suport pentru reparații sau înlocuirea pieselor defecte conform termenilor garanției. Satisfacția clientului este prioritatea noastră."
            }
        ],
        contact: {
            title: "Nu ai găsit răspunsul?",
            subtitle: "Echipa noastră este gata să te ajute cu orice întrebare",
            button: "Contactează-ne"
        }
    },

    // Footer
    footer: {
        description: "Partenerul tău de încredere pentru utilaje de construcții de calitate. Oferim vânzări profesionale de echipamente, consultanță expertă și suport complet post-vânzare.",
        quickLinks: {
            title: "Link-uri Rapide",
            home: "Acasă",
            inventory: "Inventar",
            about: "Despre Noi",
            services: "Servicii",
            contact: "Contact"
        },
        categories: {
            title: "Categorii",
            loaders: "Încărcătoare",
            excavators: "Excavatoare",
            compactors: "Compactoare",
            bulldozers: "Buldozere",
            cranes: "Macarale"
        },
        contact: {
            title: "Contactează-ne",
            location: "România",
            hours: "Program de Lucru",
            schedule: "Luni - Vineri: 8:00 - 18:00\nSâmbătă: 9:00 - 14:00"
        },
        copyright: "Toate drepturile rezervate.",
        privacy: "Politica de Confidențialitate",
        terms: "Termeni și Condiții",
        cookies: "Politica Cookie-uri"
    },

    // Contact Page
    contactPage: {
        hero: {
            title: "Contactați-ne",
            subtitle: "Suntem aici pentru a vă ajuta să găsiți utilajele perfecte"
        },
        cards: {
            phone: {
                title: "Sunați-ne",
                schedule: "Luni-Vineri 8:00 - 18:00"
            },
            email: {
                title: "Email",
                response: "Răspundem în 24 de ore"
            },
            location: {
                title: "Vizitați-ne",
                area: "Localitatea Luna, Cluj"
            },
            hours: {
                title: "Program",
                weekdays: "Luni - Vineri",
                saturday: "Sâmbătă",
                sunday: "Duminică",
                closed: "Închis"
            }
        },
        map: {
            title: "Locația Noastră",
            subtitle: "Vizitați-ne pentru a vedea utilajele în persoană"
        },
        quickContact: {
            title: "Contactați-ne Rapid",
            whatsapp: "WhatsApp",
            call: "Apelează",
            email: "Email"
        },
        social: {
            title: "Urmăriți-ne"
        },
        faq: {
            title: "Întrebări Frecvente",
            q1: {
                question: "Oferiți finanțare?",
                answer: "Da, colaborăm cu mai mulți parteneri financiari pentru a oferi planuri de plată flexibile adaptate nevoilor dumneavoastră."
            },
            q2: {
                question: "Pot testa utilajele?",
                answer: "Absolut! Programați o vizită și echipa noastră va aranja o demonstrație pentru orice utilaj la care sunteți interesat."
            },
            q3: {
                question: "Asigurați livrarea?",
                answer: "Da, oferim servicii de livrare în toată România și țările vecine la prețuri competitive."
            },
            q4: {
                question: "Ce se întâmplă cu garanția?",
                answer: "Toate utilajele noastre vin cu acoperire completă de garanție. Termenii variază în funcție de mașină și stare."
            }
        }
    },

    // Common
    common: {
        language: "Limba",
        theme: "Temă",
        lightMode: "Mod Luminos",
        darkMode: "Mod Întunecat",
        announcements: "anunțuri"
    },

    // Cookie Consent
    cookieConsent: {
        title: "Prețuim Confidențialitatea Ta",
        description: "Folosim cookie-uri pentru a îmbunătăți experiența ta, a-ți aminti preferința de limbă și a urmări vizualizările anunțurilor. Apăsând \"Acceptă Toate\", consimți la utilizarea cookie-urilor noastre.",
        customize: "Personalizează Setările",
        detailsIntro: "Alege ce cookie-uri vrei să accepți. Cookie-urile necesare sunt întotdeauna activate deoarece sunt esențiale pentru funcționarea site-ului.",
        necessary: "Cookie-uri Necesare",
        required: "Obligatorii",
        necessaryDesc: "Esențiale pentru funcționarea corectă a site-ului. Acestea nu pot fi dezactivate.",
        functional: "Cookie-uri Funcționale",
        functionalDesc: "Țin minte preferința ta de limbă și urmăresc ce anunțuri ai vizualizat pentru a oferi statistici exacte.",
        analytics: "Cookie-uri Analitice",
        optional: "Opționale",
        analyticsDesc: "Ne ajută să înțelegem cum vizitatorii folosesc site-ul nostru (momentan nefolosite).",
        langCookie: "Stochează preferința ta de limbă (RO/EN)",
        viewCookie: "Urmărește anunțurile vizualizate pentru a preveni numărarea dublă",
        acceptAll: "Acceptă Toate",
        declineAll: "Refuză Toate",
        savePreferences: "Salvează Preferințele",
        back: "Înapoi",
        footerText: "Află mai multe în",
        cookiePolicy: "Politica Cookie-urilor"
    },

    // Admin Panel
    admin: {
        images: "Imagini",
        videos: "Video",
        imageCount: "imagini",
        videoCount: "videoclipuri",
        new: "noi",
        existing: "Existente",
        deleteImage: "Șterge imagine",
        deleteVideo: "Șterge video",
        addMoreImages: "Adaugă mai multe imagini",
        addMoreVideos: "Adaugă mai multe videoclipuri",
        imageFormats: "Formate acceptate: JPG, PNG, GIF, WEBP (max 5MB fiecare)",
        videoFormats: "Formate acceptate: MP4, MOV, AVI, WMV, FLV, WebM, MKV • Max 300MB per video",
        multipleSelect: "Poți selecta multiple imagini deodată sau adăuga una câte una",
        newSelected: "noi selectate",
        limitReached: "Limită atinsă",
        maxImages: "10 imagini max",
        maxVideos: "3 videoclipuri max",
        successPublished: "Anunț publicat cu succes!",
        successUpdated: "Anunț actualizat cu succes!",
        successDeleted: "Anunț șters cu succes!",
        hotspotAdded: "Anunț adăugat în HotSpot!",
        hotspotRemoved: "Anunț eliminat din HotSpot!",
        existingImages: "Imagini existente",
        existingVideos: "Videoclipuri existente",
        newImages: "Imagini noi",
        newVideos: "Videoclipuri noi",
        contact: "Contact (Telefon)",
        location: "Locație"
    },

    // Cookie Policy
    cookiePolicy: {
        title: "Politica de Cookie-uri",
        lastUpdated: "Ultima actualizare: 27 Ianuarie 2026",
        
        section1: {
            title: "1. Ce sunt cookie-urile?",
            content: "Cookie-urile sunt fișiere text mici care sunt plasate pe computerul, tableta sau telefonul dumneavoastră mobil atunci când vizitați un site web. Cookie-urile sunt utilizate pe scară largă pentru a face site-urile web să funcționeze sau să funcționeze mai eficient, precum și pentru a furniza informații proprietarilor site-ului."
        },
        
        section2: {
            title: "2. Cum folosim cookie-urile",
            content: "MachineryA3 folosește cookie-uri pentru următoarele scopuri:",
            items: {
                essential: "Cookie-uri esențiale: Necesare pentru funcționarea de bază a site-ului, inclusiv navigarea și accesarea zonelor securizate.",
                preferences: "Cookie-uri de preferințe: Permit site-ului să rețină informații care modifică comportamentul sau aspectul site-ului, cum ar fi limba preferată sau regiunea în care vă aflați.",
                analytics: "Cookie-uri de analiză: Ne ajută să înțelegem cum vizitatorii interacționează cu site-ul nostru, colectând și raportând informații în mod anonim.",
                marketing: "Cookie-uri de marketing: Utilizate pentru a urmări vizitatorii pe site-uri web pentru a afișa anunțuri care sunt relevante și captivante pentru utilizatorul individual."
            }
        },
        
        section3: {
            title: "3. Tipuri de cookie-uri pe care le folosim",
            necessary: {
                title: "Cookie-uri strict necesare",
                description: "Aceste cookie-uri sunt esențiale pentru ca dvs. să puteți naviga pe site și să utilizați funcțiile sale. Fără aceste cookie-uri, serviciile pe care le-ați solicitat nu pot fi furnizate.",
                cookies: {
                    consent: "Stochează preferințele dvs. de consimțământ pentru cookie-uri",
                    session: "Identifică sesiunea dvs. unică pe site"
                }
            },
            performance: {
                title: "Cookie-uri de performanță",
                description: "Aceste cookie-uri colectează informații despre modul în care vizitatorii utilizează un site web, de exemplu care pagini vizitează cel mai des vizitatorii și dacă primesc mesaje de eroare de la paginile web.",
                cookies: {
                    ga: "Google Analytics: Utilizat pentru a distinge utilizatorii",
                    gid: "Google Analytics: Utilizat pentru a distinge utilizatorii",
                    viewTracking: "Urmărește vizualizările de anunțuri pentru analize interne"
                }
            },
            functional: {
                title: "Cookie-uri de funcționalitate",
                description: "Aceste cookie-uri permit site-ului web să-și amintească alegerile pe care le faceți (cum ar fi limba preferată) și oferă funcții îmbunătățite, mai personale.",
                cookies: {
                    language: "Stochează preferința de limbă (RO/EN)",
                    viewedAnnouncements: "Urmărește anunțurile vizualizate pentru statistici corecte"
                }
            },
            marketing: {
                title: "Cookie-uri de marketing",
                description: "Aceste cookie-uri sunt utilizate pentru a urmări vizitatorii pe site-uri web. Intenția este de a afișa reclame care sunt relevante și captivante pentru utilizatorul individual.",
                cookies: {
                    fbp: "Facebook Pixel: Urmărește vizitele și conversiile",
                    adsPreference: "Stochează preferințele pentru publicitate"
                }
            }
        },
        
        section4: {
            title: "4. Cookie-uri de la terți",
            content: "În unele cazuri speciale, folosim și cookie-uri furnizate de terți de încredere. Următoarea secțiune detaliază ce cookie-uri de la terți puteți întâlni prin intermediul acestui site.",
            items: {
                analytics: "Google Analytics: Unul dintre cele mai răspândite și de încredere instrumente de analiză online care ne ajută să înțelegem cum utilizați site-ul și cum putem îmbunătăți experiența dvs.",
                social: "Social Media: Cookie-uri de la platforme de social media (Facebook, Instagram) pentru a vă permite să distribuiți conținut."
            }
        },
        
        section5: {
            title: "5. Gestionarea cookie-urilor",
            content1: "Puteți controla și/sau șterge cookie-urile după cum doriți. Puteți șterge toate cookie-urile care sunt deja pe computerul dvs. și puteți configura majoritatea browser-elor pentru a împiedica plasarea lor.",
            content2: "Dacă faceți acest lucru, totuși, poate fi necesar să ajustați manual unele preferințe de fiecare dată când vizitați un site și unele servicii și funcții pot să nu funcționeze.",
            browserTitle: "Cum să gestionați cookie-urile în browser-ul dvs.:",
            browsers: {
                chrome: "Chrome: Setări → Confidențialitate și securitate → Cookie-uri și alte date ale site-urilor",
                firefox: "Firefox: Opțiuni → Confidențialitate și securitate → Cookie-uri și date ale site-urilor",
                safari: "Safari: Preferințe → Confidențialitate → Cookie-uri și date site-uri web",
                edge: "Edge: Setări → Cookie-uri și permisiuni site → Gestionați și ștergeți cookie-uri"
            }
        },
        
        section6: {
            title: "6. Consimțământul dvs.",
            content1: "Când vizitați site-ul nostru pentru prima dată, vi se va solicita să acceptați sau să respingeți cookie-urile. Puteți să vă schimbați preferințele în orice moment utilizând panoul de setări cookie-uri disponibil în pagina noastră.",
            content2: "Acceptarea cookie-urilor este complet voluntară, dar vă rugăm să rețineți că refuzul cookie-urilor poate afecta funcționalitatea site-ului."
        },
        
        section7: {
            title: "7. Durata de viață a cookie-urilor",
            content: "Durata de viață a cookie-urilor variază în funcție de tipul acestora:",
            items: {
                session: "Cookie-uri de sesiune: Temporare și sunt șterse când închideți browser-ul",
                persistent: "Cookie-uri persistente: Rămân pe dispozitivul dvs. pentru o perioadă definită sau până când le ștergeți manual"
            }
        },
        
        section8: {
            title: "8. Actualizări la această politică",
            content1: "Ne rezervăm dreptul de a actualiza această Politică de Cookie-uri periodic pentru a reflecta, de exemplu, modificările aduse cookie-urilor pe care le folosim sau din alte motive operaționale, legale sau de reglementare.",
            content2: "Vă rugăm să revizuiți periodic această Politică de Cookie-uri pentru a fi informat cu privire la utilizarea cookie-urilor și tehnologiilor conexe."
        }
    }
};
